import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../utils/api";

export default function VerifyPage() {
  const userId = localStorage.getItem("user_id");
  const [idFront, setIdFront] = useState(null);
  const [idBack, setIdBack] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await apiFetch(`/api/profile/${userId}`);
        const data = await res.json();
        if (res.ok) {
          const vRes = await apiFetch(`/api/verification/status?user_id=${userId}`);
          const vData = await vRes.json();
          if (vRes.ok) {
            data._id_pending = Boolean(vData.legacy_id_pending);
            if (vData.legacy_id_verified || vData.real_name_verified) {
              data.is_id_verified = 1;
            }
          }
          setUser(data);
        }
      } catch (err) {
        console.error("获取用户信息失败", err);
      }
    };
    if (userId) fetchUser();
  }, [userId]);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (type === "front") setIdFront(file);
    else setIdBack(file);
  };

  const handleSubmit = async () => {
    if (!idFront || !idBack) {
      alert("请上传身份证正反面图片");
      return;
    }

    setUploading(true);
    setMessage("");

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("id_front", idFront);
    formData.append("id_back", idBack);

    try {
      const res = await apiFetch("/api/verify-id", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "上传失败");

      setMessage("上传成功，等待审核");
      setIdFront(null);
      setIdBack(null);
      setUser((prev) => ({ ...prev, is_id_verified: 0, _id_pending: true }));
    } catch (err) {
      console.error(err);
      setMessage(err.message || "上传失败");
    } finally {
      setUploading(false);
    }
  };

  if (!user) {
    return <div className="text-center text-gray-400 py-10">加载中...</div>;
  }

  const pending = Boolean(user._id_pending) || (user.id_front_path && !user.is_id_verified);
  const statusText = user.is_id_verified
    ? "已通过"
    : pending
    ? "待审核"
    : "未认证";

  return (
    <div className="space-y-6 max-w-lg">
      <Link to="/center/verify" className="text-sm text-pink-500 hover:underline">
        ← 返回认证中心
      </Link>

      <div className="space-y-2">
        <h2 className="text-2xl font-bold text-gray-800">上传身份证</h2>
        <p className="text-sm text-gray-500 leading-7">
          人工审核通道。也可在认证中心使用模拟/第三方实名认证。上传后由管理员审核。
        </p>
        <p className="text-sm text-gray-600">
          当前状态：
          <span className="font-medium text-pink-500 ml-1">{statusText}</span>
        </p>
      </div>

      <div className="bg-white rounded-2xl border p-5 space-y-4">
        <div>
          <label className="block text-gray-700 mb-1 font-medium text-sm">
            身份证正面
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "front")}
            className="w-full text-gray-600 text-sm"
          />
          {idFront && (
            <img
              src={URL.createObjectURL(idFront)}
              alt="身份证正面"
              className="mt-2 w-full h-40 object-contain rounded border border-gray-300"
            />
          )}
        </div>

        <div>
          <label className="block text-gray-700 mb-1 font-medium text-sm">
            身份证反面
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "back")}
            className="w-full text-gray-600 text-sm"
          />
          {idBack && (
            <img
              src={URL.createObjectURL(idBack)}
              alt="身份证反面"
              className="mt-2 w-full h-40 object-contain rounded border border-gray-300"
            />
          )}
        </div>

        <button
          type="button"
          onClick={handleSubmit}
          disabled={uploading || user.is_id_verified === 1}
          className={`w-full py-3 rounded-xl text-white text-base font-medium transition ${
            uploading || user.is_id_verified === 1
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-pink-500 hover:bg-pink-600"
          }`}
        >
          {uploading ? "上传中..." : user.is_id_verified === 1 ? "已通过认证" : "提交认证"}
        </button>

        {message ? (
          <p className="text-center text-gray-700 text-sm font-medium">{message}</p>
        ) : null}
      </div>
    </div>
  );
}
